module.exports = __webpack_public_path__ + "img/projects.d5522b38.jpg";